import { axiosInstance } from '@/plugins/axios';

const action = {
  cityByCityName: 'candao.base.getCityByCityName', // 根据城市名称获取城市ID
  district: 'candao.base.listDistrict', // 获取区域列表
};

const base = {
  getCityByCityName: ({ actionName = action.cityByCityName, ...data }) => axiosInstance({
    method: 'post',
    url: 'Action',
    params: {
      method: 'getCityByCityName',
    },
    data: {
      actionName,
      ...data,
    },
  }),
  district: ({ actionName = action.district, ...data }) => axiosInstance({ // 获取区域列表
    method: 'post',
    url: 'Action',
    params: {
      method: 'listDistrict',
    },
    data: {
      actionName,
      ...data,
    },
  }),
};

export default base;
